module.exports = __webpack_public_path__ + "static/media/device_plus_app@3x.7a1bb491.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/device_plus_app@3x.png
// module id = 549
// module chunks = 0